import BaseApiRequest from "./BaseApiRequest";
import { RECOVERPASSWORD_URL } from "../ApiUrls";
import { METHOD } from "../Constants";

class ForgotPasswordRequest extends BaseApiRequest {
  method = METHOD.HTTP.POST;

  body = {
    credential: "",
    otpTo: "",
  };

  constructor(userDetail) {
    super();
    this.body.credential = userDetail.credential;
    this.body.otpTo = userDetail.otpTo;
  }

  getMethod = () => {
    return this.method;
  };

  getUrl = () => {
    return RECOVERPASSWORD_URL;
  };

  getBody = () => {
    return this.body;
  };
}

export default ForgotPasswordRequest;
